import React from 'react'
import LoadingSpinner from 'Components/LoadingSpinner'
import { Responsive } from 'responsive-react'
import { Table, Row } from 'react-bootstrap'
import { ListLayout } from 'Components/Layouts'
import { useTranslation } from 'react-i18next'
import ProviderCard from './ProviderCard'
import ActionButtons from './ActionButtons'
import { useProvidersQuery } from 'hooks/useProvidersQuery'

const ProvidersList = () => {
  const { t } = useTranslation()
  const { data: providers = [], isLoading } = useProvidersQuery()

  return (
    <ListLayout title="providers">
      {isLoading && <LoadingSpinner />}

      {!isLoading && (
        <>
          {providers.length === 0 && <h2>{t('not_providers_found')}</h2>}
          {providers.length > 0 && (
            <>
              <Responsive displayIn={['Laptop']}>
                <Table striped bordered hover>
                  <thead>
                    <tr className="text-center">
                      <th>{t('legal_name')}</th>
                      <th>{t('legal_identification')}</th>
                      <th>{t('address')}</th>
                      <th>{t('phone')}</th>
                      <th>{t('email')}</th>
                      <th>{t('vat_withholding_percentage')}</th>
                      <th>{t('actions')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {providers.map(provider => (
                      <tr className="text-center" key={provider.Id}>
                        <td>{provider.BusinessName}</td>
                        <td>{provider.Rif}</td>
                        <td>{provider.FiscalAddress}</td>
                        <td>{provider.PhoneNumber}</td>
                        <td>{provider.Email}</td>
                        <td className="text-right">{provider.WithholdingPercentageIVA}%</td>
                        <td><ActionButtons idProvider={provider.Id} /></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Responsive>
              <Responsive displayIn={['Mobile', 'Tablet']}>
                <Row>
                  {providers.map(provider => (
                    <ProviderCard key={provider.Id} provider={provider} />
                  ))}
                </Row>
              </Responsive>
            </>
          )}
        </>
      )}
    </ListLayout>
  )
}

export default ProvidersList
